import { useGetAllTenantsQuery } from 'gql/graphql';
import { useMemo } from 'react';
import { env as envConfig } from 'features/common/config/envConfig';
import { adaptGraphQLDataTenantToUserEnvironmentObject } from '../../../../common/utils/dataAdapters';

export const useFetchTenantsData = () => {
  const { data: tenantsQueryData, loading: areTenantsLoading } =
    useGetAllTenantsQuery({
      variables: {
        first: 100,
        env: envConfig,
        productCode: 'mkpdevelopers',
      },
    });

  const transformedData = useMemo(
    () =>
      adaptGraphQLDataTenantToUserEnvironmentObject({
        //@ts-ignore
        tenantsQueryData,
      }),
    [tenantsQueryData],
  );

  const tenantsData = useMemo(
    () => transformedData.tenantsData || [],
    [transformedData.tenantsData],
  );
  const isLoading = useMemo(() => areTenantsLoading, [areTenantsLoading]);

  return {
    tenantsData,
    isLoading,
  };
};
